<template>
  <v-menu transition="slide-y-transition" bottom min-width="250px">
    <template v-slot:activator="{ on }">
      <v-btn icon color="primary" flat small v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar color="primary" class="white--text">{{
          userName ? userName.substring(0, 1) : "?"
        }}</v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ userName }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ accountable }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider></v-divider>

      <v-list-tile @click.stop="openChangePwd">
        <v-list-tile-title>Alterar a senha</v-list-tile-title>
      </v-list-tile>

      <v-list-tile @click.stop="logout">
        <v-list-tile-title>Sair</v-list-tile-title>
      </v-list-tile>
    </v-list>

    <ChangePassword
      :resetPwdDialog="resetPwdDialog"
      :closeDialog="(_) => closeDialog()"
    />
  </v-menu>
</template>

<script>
import ChangePassword from './ChangePassword'

export default {
  components: {
    ChangePassword
  },

  data () {
    return {
      userName: '',
      accountable: '',
      resetPwdDialog: false
    }
  },

  mounted () {
    this.getUser()
  },

  methods: {
    async getUser () {
      const user = await JSON.parse(localStorage.getItem('userData'))

      this.userName = user.name
      this.accountable = user.accountable || user.email

      return user
    },

    closeDialog () {
      this.resetPwdDialog = false
    },

    openChangePwd () {
      this.resetPwdDialog = true
    },

    logout () {
      const _this = this

      let obj = {
        url: '/api/logout',
        query: '',
        method: 'post'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (response) {
          localStorage.clear()
          let obj = {
            bg: './img/insight_img_bg_1.jpg',
            logo: './img/ajax-loader.gif'
          }
          this.$vuetify.theme.primary = '#002857'
          this.$store.commit('setNewThemeSystem', obj)
          _this.$router.push('/login')
        }
      })

      return true
    }
  }
}
</script>
